import { AfterViewChecked, Directive, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[appTemplateVariable]'
})
export class TemplateVariableDirective implements AfterViewChecked {
  fname: string;
  constructor(private el: ElementRef, private route: ActivatedRoute) {
  }

  ngAfterViewChecked(): void {
    this.fname = history.state.data;
    const tags = this.el.nativeElement.getElementsByTagName('*');
    const fname = tags[0].childNodes[0].nodeValue.replace(/fname/gi, this.fname);
    tags[0].childNodes[0].nodeValue = fname;
  }
}
